// Component: src/theme/snippets/accordion-item.liquid

export const EVENT_OPEN = "accordion-item:open";
export const EVENT_CLOSE = "accordion-item:close";

export const initAccordionItems = () => {
  const accordionItems = document.querySelectorAll(".accordion-item");

  accordionItems.forEach((accordionItem) => {
    if (accordionItem.dataset.initialized) {
      return;
    }

    let parent = accordionItem.parentElement!;
    if (accordionItem.dataset.twoLevelParent) {
      parent = parent.parentElement!;
    }
    const header = accordionItem.querySelector(".accordion-item-header")!;
    const icon = accordionItem.querySelector(".accordion-item-icon")!;
    const content = accordionItem.querySelector(".accordion-item-content")!;

    const closeIcon = accordionItem.dataset.closeIcon || window.accordionItemData?.closeIcon || "";
    const openIcon = accordionItem.dataset.openIcon || window.accordionItemData?.openIcon || "";

    if (accordionItem.classList.contains("is-open")) {
      // content.style.height = content.scrollHeight + "px";
    }

    accordionItem.addEventListener(
      EVENT_CLOSE,
      () => {
        // content.style.maxHeight = "0px";
        icon.innerHTML = closeIcon;
        accordionItem.classList.remove("is-open");
      },
      { passive: true },
    );

    accordionItem.addEventListener(
      EVENT_OPEN,
      () => {
        // content.style.maxHeight = content.scrollHeight + "px";
        icon.innerHTML = openIcon;
        accordionItem.classList.add("is-open");
      },
      { passive: true },
    );

    const siblingItems = parent.querySelectorAll(".accordion-item");

    header.addEventListener("click", () => {
      if (accordionItem.classList.contains("is-open")) {
        accordionItem.dispatchEvent(new CustomEvent(EVENT_CLOSE));
      } else {
        accordionItem.dispatchEvent(new CustomEvent(EVENT_OPEN));
      }

      siblingItems.forEach((item) => {
        if (accordionItem !== item) {
          item.dispatchEvent(new CustomEvent(EVENT_CLOSE));
        }
      });
    });

    accordionItem.dataset.initialized = true;
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initAccordionItems();
});
